import React from "react";
import "./styles.css";

const TermsAndCondition = () => {
  return (
    <React.Fragment>
      <span className="root">
        <span className="header">
          CONTRATTO DI LICENZA PER L’UTENTE FINALE DEL SOFTWARE TREND AnyWARE®
        </span>

        <span className="lineBreak">
          FACENDO CLIC SUL PULSANTE “ACCETTO” DI SEGUITO L’UTENTE ACCETTA DI
          ESSERE VINCOLATO DAI TERMINI DEL PRESENTE CONTRATTO DI LICENZA
        </span>

        <span className="lineBreak">
          Questo contratto di licenza per l’utente finale, come da noi
          modificato di volta in volta ai sensi della clausola 12 (<b>EULA</b>
          ), è un accordo legalmente vincolante tra l’utente (una persona fisica
          o giuridica) e TREND Networks Limited (<b>TREND</b>) per l’utilizzo e
          l’accesso al software TREND AnyWARE®, accluso al presente EULA ed
          eventualmente comprensivo di supporti associati, materiali stampati,
          documentazione “online” o elettronica e servizi basati su Internet (
          <b>Software</b>). Il software consente di interfacciarsi e accedere ai
          dati da apparecchiature di prova, dispositivi e strumenti compatibili
          di TREND (<b>Strumenti</b>). È possibile accedere al Software
          utilizzando i browser di qualsiasi dispositivo o quelli scaricati e
          installati su un computer.
        </span>

        <span className="lineBreak">
          <b>IMPORTANTE: LEGGERE ATTENTAMENTE I TERMINI DEL PRESENTE EULA.</b>
          CONTIENE TERMINI IMPORTANTI CHE INTERESSANO L’UTENTE E L’USO DEL
          SOFTWARE DA PARTE DELLO STESSO, E DEVE ESSERE VALUTATA E CONFRONTATA
          CON QUALSIVOGLIA VERSIONE PIÙ RECENTE DELL’EULA SE E QUANDO
          QUEST’ULTIMA VENGA ADOTTATA. MEDIANTE LA CREAZIONE DI UN ACCOUNT,
          L’INSTALLAZIONE O ALTRO TIPO DI ACCESSO O UTILIZZO DEL SOFTWARE O DI
          QUALSIASI PARTE DELLO STESSO, L’UTENTE DÀ ATTO DI AVER LETTO, COMPRESO
          E ACCETTA DI ESSERE VINCOLATO DAI TERMINI DEL PRESENTE EULA PER
          PROPRIO CONTO E, SE PERTINENTE, PER CONTO DELL’AZIENDA O DELL’ENTITÀ
          PRESSO CUI L’UTENTE PRESTA SERVIZIO O CHE RAPPRESENTA. SE L’UTENTE NON
          ACCETTA TALI TERMINI, NON DOVRÀ ACCEDERE, INSTALLARE, COPIARE O
          UTILIZZARE IL SOFTWARE E QUALORA NON DOVESSE ACCETTARE LE EVENTUALI
          MODIFICHE APPORTATE AL PRESENTE EULA NON AVRÀ PIÙ ALCUN DIRITTO O
          LICENZA DI ACCEDERE O UTILIZZARE IL SOFTWARE, E DOVRÀ DISINSTALLARE
          IMMEDIATAMENTE IL SOFTWARE E/O INTERROMPERE QUALSIASI ACCESSO O
          UTILIZZO ALLO/DELLO STESSO.
        </span>

        <span className="lineBreak">
          L’UTENTE DICHIARA E GARANTISCE DI AVER STIPULATO IL PRESENTE CONTRATTO
          NELL’AMBITO DELLA CONDUZIONE DELLA PROPRIA ATTIVITÀ O PER FINALITÀ
          AZIENDALI (E NON COME CONSUMATORE). TUTTAVIA, NEL CASO IN CUI LA
          NORMATIVA A TUTELA DEL CONSUMATORE SI APPLICHI AI SENSI DELLA
          LEGISLAZIONE DI RIFERIMENTO, IL PRESENTE CONTRATTO DI LICENZA NON
          OSTACOLERÀ NÉ PREGIUDICHERÀ ALCUN DIRITTO LEGALE DEL CONSUMATORE
          RICONOSCIUTO ALL’UTENTE DALLA LEGISLAZIONE DI RIFERIMENTO. SE STIPULA
          IL PRESENTE EULA PER CONTO DI UNA SOCIETÀ O DI UN ALTRA ENTITÀ
          GIURIDICA, L’UTENTE DICHIARA E GARANTISCE DI AVERE L’AUTORITÀ DI
          VINCOLARE TALE SOCIETÀ O ENTITÀ AI TERMINI DEL PRESENTE EULA; IN TAL
          CASO I TERMINI “UTENTE” O “SUO” SI RIFERIRANNO ANCHE ALLA SOCIETÀ O
          ALL’ENTITÀ RAPPRESENTATE O PRESSO CUI L’UTENTE PRESTA SERVIZIO NONCHÉ
          ALLE COLLEGATE E A CIASCUNO DEI RISPETTIVI AMMINISTRATORI, FUNZIONARI,
          DIPENDENTI, AGENTI E RAPPRESENTANTI.
        </span>

        <ol>
          <li>
            <b> USO DEL SOFTWARE</b>
            <ol>
              <li>
                Fermo restando il rispetto dei termini del presente EULA da
                parte dell’utente, TREND concede allo stesso il diritto e una
                licenza non esclusiva, non trasferibile, non sublicenziabile e
                revocabile di scaricare, installare, attivare, accedere o
                utilizzare in altro modo le versioni del codice oggetto del
                Software su un dispositivo posseduto o gestito dall’utente,
                esclusivamente per le proprie attività interne, come consentito
                dal presente EULA.
              </li>
              <li>
                L’utente potrà concedere a terzi e/o utenti all’interno della
                propria società o organizzazione (<b>Utenti autorizzati</b>) il
                diritto di accedere al Software e di utilizzarlo nel regolare
                svolgimento del proprio lavoro, qualora tale uso avvenga
                esclusivamente: (i) per conto dell’utente; (ii) per le attività
                interne; e (iii) in conformità al presente EULA. L’utente si
                assicurerà che tutti gli Utenti autorizzati abbiano accettato di
                rispettare i termini del presente EULA, siano stati informati in
                merito alla raccolta, all’uso e alla comunicazione dei loro dati
                personali da parte di TREND in conformità ai termini
                dell’Informativa sulla privacy di TREND e vi abbiano
                acconsentito, prima di fornire agli Utenti autorizzati l’accesso
                al Software. Tutti i riferimenti a “utente” o “Suo” nel presente
                EULA saranno inoltre interpretati per fare riferimento agli
                Utenti autorizzati. L’utente è responsabile di: (a) identificare
                e autenticare tutti gli Utenti autorizzati; (b) approvare
                l’accesso di tali Utenti Autorizzati al Software; (c) garantire
                la conformità degli Utenti autorizzati al presente EULA; (d)
                verificare gli accessi non autorizzati o l’uso da parte di
                Utenti Autorizzati; (e) mantenere la riservatezza di nomi
                utente, password e dati dell’account; e (f) fornire le notifiche
                od ottenere i consensi necessari agli/dagli Utenti Autorizzati
                come richiesto dalla legge applicabile, incluso, a titolo
                esemplificativo ma non esaustivo, prima di attivare la funzione
                di tracciamento della posizione sugli Strumenti. TREND non è
                responsabile per eventuali danni causati dagli Utenti
                autorizzati, incluse le persone fisiche non autorizzate ad
                accedere al Software, ma in grado di ottenervi accesso, a causa
                della mancata cancellazione in tempo debito di nomi utente,
                password o account nell’infrastruttura locale di gestione delle
                identità, sui dispositivi locali o altrimenti da parte
                dell’utente o per conto dello stesso. L’utente è responsabile di
                tutte le attività che si verificano ai sensi o in connessione
                con nomi utente, password o account dei propri Utenti
                autorizzati o a seguito dell’accesso dell’utente o dell’Utente
                autorizzato al Software e accetta di informare TREND
                immediatamente, per iscritto, di qualsiasi uso non autorizzato.
                L’utente accetta di compiere ogni ragionevole sforzo per
                impedire a terzi non autorizzati di accedere al Software.
                L’utente sarà responsabile per tutti gli atti e le omissioni di
                qualsiasi Utente autorizzato e dovrà indennizzare TREND per
                tutti i costi, le spese, i reclami, le perdite o i danni
                arrecati a TREND o subiti dalla stessa, o per cui TREND possa
                diventare responsabile (a prescindere se diretti, indiretti o
                consequenziali, ivi compresa qualsiasi perdita economica o altra
                perdita di profitto, volume d’affari o avviamento) derivanti da
                atti od omissioni di qualsiasi Utente autorizzato.
              </li>
              <li>
                È necessario designare uno o vari Utenti autorizzati come
                amministratore (<b>Amministratore</b>) dell’account dell’utente.
                L’utente accetta che l’Amministratore possa concedere e revocare
                l’accesso e i diritti d’utilizzo di altri Utenti autorizzati per
                conto dell’utente in qualsiasi momento e per qualsiasi motivo. È
                possibile sostituire l’Amministratore o gli Amministratori in
                qualsiasi momento e per qualsiasi motivo, aggiornandone la
                nomina.
              </li>
              <li>
                L’utente conviene di essere l’unico responsabile (e dell’assenza
                di responsabilità in capo a TREND nei confronti dell’utente o di
                terzi) per l’utilizzo del Software, eventuali violazioni dei
                propri obblighi ai sensi del presente EULA e per le conseguenze
                (comprese eventuali perdite o danni subiti da TREND) di tali
                violazioni.
              </li>
              <li>
                L’utente potrà accedere al Software dai propri dispositivi
                utilizzando un browser. È possibile scaricare e installare una
                versione standalone su PC con sistema operativo Microsoft
                Windows. La versione standalone consente la comunicazione con
                gli Strumenti tramite connessione diretta, non attraverso
                Internet.
              </li>
              <li>
                Per scaricare, installare, attivare, accedere o utilizzare in
                altro modo il Software sarà necessario registrarsi per un
                account. TREND si riserva il diritto, a sua esclusiva e assoluta
                discrezione, di rifiutare qualsiasi registrazione. In
                considerazione dell’uso del Software, l’utente accetta di: (i)
                fornire informazioni relative all’account esatte, aggiornate e
                complete; (ii) mantenere e aggiornare tempestivamente le
                informazioni del proprio account; (iii) mantenere la sicurezza
                della/e password e accettare tutti i rischi connessi all’accesso
                non autorizzato al proprio account e alle informazioni fornite a
                TREND; e (iv) comunicarci tempestivamente qualsiasi violazione
                della sicurezza, effettiva o presunta, relativa al Software o
                all’utilizzo dello stesso da parte dell’utente.
              </li>
              <li>
                Per permettere a TREND di fornire servizi, manutenzione e
                assistenza in relazione al Software, l’utente dovrà garantire ad
                TREND la collaborazione necessaria a consentirle di accedere al
                proprio account e di utilizzarlo come se fosse gestito dal
                medesimo utente. Tale accesso autorizzato include il
                conferimento a TREND del diritto di visualizzazione, modifica ed
                eliminazione dei dati.
              </li>
              <li>
                Nella misura consentita dalla legge, TREND può eliminare i dati
                dell’utente nella misura in cui qualsiasi azione od omissione
                del medesimo non sia conforme al presente EULA. TREND cercherà
                di informare l’utente prima dell’eliminazione di tali dati,
                senza però violare il presente EULA qualora non fosse in grado
                di farlo. Se l’utente scarica i suoi dati eliminandoli dal
                nostro server o dai nostri server esterni, tali dati scaricati
                ed eliminati non saranno più accessibili tramite il Software, il
                nostro server o i nostri server esterni.
              </li>
              <li>
                L’utente è l’unico responsabile di fornire e mantenere a proprie
                spese tutti gli strumenti, apparecchiature, software, servizi e
                altri elementi necessari all’utilizzo del Software e degli
                Strumenti (inclusi, a titolo esemplificativo ma non esaustivo,
                hardware o software, modem, servizio telefonico e accesso a
                Internet del computer o del dispositivo).
              </li>
              <li>
                L’utente riconosce che l’uso del Software può richiedere una
                connessione a Internet e di poter incorrere in spese per
                traffico dati relative alle informazioni trasmesse (inviate o
                ricevute) dal suo dispositivo durante l’utilizzo del Software.
                L’utente è l’unico responsabile per tali spese per traffico
                dati.
              </li>
            </ol>
          </li>

          <li>
            <b> RISERVA DI DIRITTI E PROPRIETÀ</b>
            <ol>
              <li>
                Il software è concesso in licenza (non è venduto) all’utente,
                esclusivamente per l’uso in conformità ai termini del presente
                EULA. Il titolo, la proprietà e tutti i diritti: (i) del/sul
                Software (compresi, a titolo esemplificativo ma non esaustivo,
                tutti i diritti di proprietà intellettuale); e (ii) di/su tutti
                i contenuti e altri materiali forniti da TREND o dai nostri
                concessori di licenza esterni, compresi, tra le altre cose, i
                loghi TREND e TREND AnyWARE® e tutti i design, testi, grafiche,
                immagini, informazioni, dati, software, file audio, altri file e
                la selezione e la disposizione degli stessi (collettivamente, i
                Contenuti), sono esclusivi e riservati di TREND o dei nostri
                concessori di licenza, a seconda dei casi, e sono protetti da
                diritti d’autore e altri diritti di proprietà intellettuale e
                dalle leggi applicabili e continueranno a essere detenuti da
                TREND. TREND si riserva tutti i diritti non espressamente
                concessi all’utente nel presente EULA, restando escluso
                qualsiasi altro diritto, sia esplicito sia implicito.
              </li>
              <li>
                “TREND”, “TREND Networks”, “TREND AnyWARE”, “LanTEK”, “TREND
                Networks”, “FiberTEK”, “SignalTEK”, “NaviTEK”, “SecuriTEST”,
                “LanXPLORER”, “UniPRO MGig1” e i loghi TREND Networks e TREND
                AnyWARE® e qualsiasi altro nome, logo o slogan di prodotti o
                servizi TREND, contenuti o mostrati nel/sul Software o nei/sui
                Contenuti, sono marchi commerciali di TREND e nessuno di essi,
                né alcun nome, logo o slogan confusorio, potrà essere copiato,
                imitato o usato, interamente o parzialmente, senza il previo
                consenso scritto di TREND. I marchi di terzi contenuti o
                mostrati nel/sul Software o nei/sui Contenuti sono di proprietà
                di tali terzi e non possono essere utilizzati senza
                l’autorizzazione del titolare del marchio commerciale
                pertinente. Non è consentito impiegare metatag o altri “testi
                nascosti” utilizzando il nome “TREND” o qualsiasi altro nome,
                marchio commerciale o nome di prodotto o servizio di TREND senza
                il nostro previo consenso scritto. Inoltre, l’apparenza visiva e
                le modalità di interazione (look and feel) del Software, incluse
                tutte le intestazioni di pagina, le grafiche personalizzate, le
                icone e gli script dei pulsanti, sono il marchio di servizio, il
                marchio commerciale e/o la veste grafica di TREND e non possono
                essere copiati, imitati o usati, interamente o parzialmente,
                senza il nostro previo consenso scritto. Il riferimento a
                qualsiasi prodotto, servizio, processo o altra informazione, per
                nome, marchio commerciale, produttore, fornitore o altrimenti
                non costituisce né implica l’approvazione, la sponsorizzazione o
                la raccomandazione dello stesso da parte di TREND.
              </li>
            </ol>
          </li>

          <li>
            <b> RESTRIZIONI E LIMITAZIONI </b>
            <ol>
              <li>
                L’utente conviene e accetta di utilizzare il Software
                esclusivamente in conformità a tutte le leggi vigenti nella
                giurisdizione in cui utilizza il Software. In caso di violazione
                del presente EULA, l’utente potrà essere perseguito legalmente e
                tenuto al risarcimento dei danni.
              </li>
              <li>
                L’utente non consentirà a terzi di:
                <ol>
                  <li>
                    Scaricare, installare, attivare, accedere o utilizzare in
                    altro modo il Software o i Contenuti su qualsiasi
                    dispositivo non posseduto o gestito legalmente;
                  </li>
                  <li>
                    Pubblicare, discutere, rilasciare, trasmettere o diffondere
                    altrimenti a terzi, i risultati dei test eseguiti sull’uso
                    degli Strumenti;
                  </li>
                  <li>
                    Tradurre, fondere, adattare, variare, alterare o modificare
                    l’integralità o qualsiasi parte del Software e neppure di
                    combinare o incorporare parti dello stesso con/in qualsiasi
                    altro programma;
                  </li>
                  <li>
                    Retroingegnerizzare, decompilare, modificare, disassemblare
                    l’integralità o qualsiasi parte del Software o tentare di
                    ricavarne il codice sorgente, salvo e solo nella misura in
                    cui tale attività sia espressamente consentita dalla legge
                    applicabile;
                  </li>
                  <li>
                    Rimuovere o alterare qualsiasi avviso o marchio proprietario
                    del Software;
                  </li>
                  <li>
                    Creare opere derivate basate sull’integralità o qualsiasi
                    parte del Software;
                  </li>
                  <li>
                    Copiare o riprodurre il Software al di fuori della propria
                    organizzazione;
                  </li>
                  <li>
                    Vendere, cedere, concedere in licenza, distribuire,
                    affittare, noleggiare, concedere in sublicenza, prestare,
                    fornire o rendere altrimenti disponibile il Software, in
                    qualsiasi forma, in tutto o in parte, a chicchessia senza il
                    previo consenso scritto di TREND;
                  </li>
                  <li>
                    Utilizzare il Software in modo illecito, per scopi illeciti
                    o in modo difforme dai presenti termini o agire in modo
                    fraudolento o doloso, ad esempio, inserendo codici malevoli,
                    come virus o dati dannosi, nel Software o nel sistema
                    operativo;
                  </li>
                  <li>
                    Violare i nostri diritti di proprietà intellettuale o quelli
                    di terzi in relazione all’uso del Software da parte
                    dell’utente, incluso tramite l’invio di materiali (nella
                    misura in cui tale uso non sia concesso in licenza da questi
                    termini);
                  </li>
                  <li>
                    Trasmettere materiale diffamatorio, offensivo o altrimenti
                    discutibile in relazione all’uso del Software;
                  </li>
                  <li>
                    Utilizzare il Software in qualsiasi modo che possa
                    danneggiare, disattivare, sovraccaricare o compromettere il
                    Software (o i server o le reti connessi al Software);
                  </li>
                  <li>
                    Utilizzare il Software in qualsiasi modo che possa
                    interferire con l’uso e la fruizione del Software da parte
                    di un’altra persona (o di server o reti connessi al
                    Software);
                  </li>
                  <li>
                    Sviluppare applicazioni di terzi che interagiscono con il
                    Software senza il previo consenso scritto di TREND;
                  </li>
                  <li>
                    Raccogliere o ricavare informazioni o dati attraverso l’uso
                    del Software o dei sistemi TREND fatto dall’utente o tentare
                    di decifrare qualsiasi trasmissione verso o dai server che
                    eseguono il Software; o
                  </li>
                  <li>
                    Utilizzare il Software per scopi per cui non è stato
                    progettato o destinato o per scopi diversi da quelli
                    descritti nel presente documento.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b> RACCOLTA E USO DEI DATI</b>
            <ol>
              <li>
                L’utente accetta che TREND e le sue collegate possano
                raccogliere e utilizzare informazioni tecniche dedotte
                nell’ambito degli eventuali servizi di assistenza per il
                prodotto forniti all’utente con riguardo al Software. TREND può
                utilizzare queste informazioni esclusivamente per migliorare i
                propri prodotti o fornire servizi o tecnologie personalizzati
                all’utente e non divulgherà tali informazioni sotto forme che
                consentano di identificare l’utente.
              </li>
              <b className="subHeading">Dati personali</b>
              <li>
                L’utente dà atto del fatto che quando scarica, installa, attiva
                il Software, vi accede o lo utilizza altrimenti, TREND può
                avvalersi di mezzi automatizzati (inclusi, ad esempio, cookie e
                web beacon) per raccogliere informazioni sul dispositivo
                dell’utente e sull’uso fatto del Software. All’utente e ai suoi
                Utenti autorizzati potrebbe anche essere richiesto di fornire
                determinati dati personali come condizione per il download,
                l’installazione, l’attivazione, l’accesso o l’utilizzo del
                Software o di alcune delle sue caratteristiche o funzionalità.
                Ai sensi della normativa sulla protezione dei dati, siamo tenuti
                a fornire all’utente alcune informazioni su chi siamo, come
                trattiamo i suoi dati personali e per quali finalità, i suoi
                diritti in relazione ai dati personali e come esercitarli.
                Queste informazioni sono fornite nell’informativa sulla privacy
                di TREND, consultabile alla pagina
                <a
                  href="https://www.trend-networks.com/privacy-policy/"
                  target="_blank"
                >
                  <b>
                    https://www.trend-networks.com/privacy-policy/
                  </b>
                </a>
                , e suscettibile di aggiornamenti periodici senza preavviso (
                <b>Informativa sulla privacy</b>). È importante che l’utente
                legga l’Informativa sulla privacy. Tramite il download,
                l’installazione, l’attivazione, l’utilizzo del Software o
                l’accesso al medesimo e la trasmissione di informazioni al
                Software o per mezzo dello stesso, l’utente acconsente a
                qualsiasi uso e azione intrapresa da TREND in relazione ai
                propri dati ai sensi dell’Informativa sulla privacy.
              </li>
              <li>
                L’utente deve tenere presente che le trasmissioni mediante
                Internet non sono mai completamente private o sicure e che i
                messaggi o le informazioni inviati avvalendosi del Software
                possono essere letti o intercettati da altri, perfino in
                presenza di un avviso speciale indicante la crittografia di una
                determinata trasmissione.
              </li>
              <b className="subHeading">Dati dell’utente finale </b>
              <li>
                In relazione al software, TREND può raccogliere e conservare i
                dati inseriti o caricati dall’utente o per conto dello stesso
                tramite il Software, incluse, a titolo esemplificativo ma non
                esaustivo, le informazioni relative all’uso degli Strumenti
                effettuato dall’utente e dagli Utenti autorizzati dello stesso (
                <b>Dati dell’utente finale</b>). L’utente sarà titolare di tutti
                i Dati dell’utente finale e accetta la responsabilità esclusiva
                di tali dati. TREND manterrà tutte le componenti identificative
                dei Dati dell’utente finale come riservate ai sensi
                dell’Informativa sulla privacy. Tutti i terzi autorizzati da
                TREND che potrebbero avere accesso ai Dati dell’Utente finale
                saranno soggetti a obblighi di riservatezza e saranno tenuti ad
                adempiere tutte le leggi pertinenti in materia di protezione dei
                dati. L’utente conviene di concedere per mezzo del presente
                documento a TREND il diritto e la licenza irrevocabile,
                perpetua, priva di royalty, trasferibile e sublicenziabile di
                utilizzare, riprodurre, modificare, adattare, tradurre,
                divulgare, commercializzare, assegnare, trasmettere, vendere,
                noleggiare, concedere in licenza o trasferire la totalità o
                parte dei Dati dell’utente finale, nella misura in cui non
                contengano dati personali. Caricando o trasmettendo i Dati
                dell’utente finale nell’ambito dell’utilizzo del Software,
                l’utente dichiara e garantisce che: (i) tali Dati dell’utente
                finale non sono soggetti a obblighi di riservatezza nei
                confronti di terzi che potrebbero essere violati dall’uso degli
                stessi in conformità ai termini del presente EULA; (ii) possiede
                e controlla tutti i diritti relativi ai Dati dell’utente finale
                che crea, carica, trasmette ovvero dispone altrimenti di tutti i
                diritti necessari per creare, caricare o trasmettere tali Dati
                dell’utente finale nell’ambito dell’uso del Software; (iii) i
                Dati dell’utente finale sono esatti e in alcun modo fuorvianti o
                dannosi; e (iv) i Dati dell’utente finale e l’utilizzo,
                caricamento e trasmissione degli stessi da parte dell’utente non
                violerà i termini del presente EULA o di qualsiasi normativa o
                regolamento applicabile. In deroga a qualsiasi altro termine del
                presente EULA, TREND potrà in qualsiasi momento: (a) eliminare i
                Dati dell’Utente Finale e/o (b) sospendere il suo account e
                accedere al Software. L’utente dovrà assicurarsi di conservare
                delle copie di tutti i Dati dell’utente finale caricati,
                trasmessi o inviati a TREND tramite il Software e TREND non avrà
                alcuna responsabilità per la perdita di qualsiasi Dato
                dell’Utente finale né per le perdite generate dal mancato
                utilizzo del Software.
              </li>
              <b className="subHeading">Dati di TREND</b>
              <li>
                Tutte le informazioni, ivi compresi, a titolo esemplificativo ma
                non esaustivo, dati, analisi, misurazioni, report, tendenze e
                metriche, generate e/o derivate da, basate su o relative ai Dati
                dell’utente finale (<b>Dati di TREND</b>) sono di esclusiva
                proprietà di TREND. TREND ha il diritto di utilizzare,
                raccogliere, conservare, creare, aggregare, estrarre,
                analizzare, modificare, commercializzare, alienare, trasmettere,
                vendere, noleggiare o trasferire i Dati di TREND in qualsiasi
                forma, per qualsiasi scopo e in qualsiasi modo.
              </li>
            </ol>
          </li>

          <li>
            <b> AGGIORNAMENTI</b>
            <ol>
              <li>
                TREND potrà modificare il Software senza preavviso, ivi
                compreso, a titolo esemplificativo ma non esaustivo, le
                funzionalità o l’aspetto del medesimo.
              </li>
              <li>
                TREND avrà la facoltà di sviluppare e fornire di volta in volta
                aggiornamenti del Software che possono includere upgrade,
                correzioni di bug, patch e altre correzioni degli errori e/o
                nuove caratteristiche (collettivamente, e compresa la
                documentazione correlata, <b>“Aggiornamenti”</b>). Gli
                Aggiornamenti potranno anche modificare o eliminare nella loro
                interezza alcune caratteristiche e funzionalità. L’utente
                riconosce che TREND non ha alcun obbligo di fornire
                Aggiornamenti o di continuare a fornire o abilitare particolari
                caratteristiche o funzionalità. In base alle impostazioni del
                dispositivo, quando il dispositivo dell’utente è connesso a
                Internet: (i) il Software scaricherà automaticamente e
                installerà tutti gli Aggiornamenti disponibili; oppure (ii) sarà
                possibile ricevere notifiche o suggerimenti di download e
                installazione degli Aggiornamenti disponibili. Per poter
                utilizzare appieno il Software, sarà necessario scaricare e
                installare tempestivamente tutti gli aggiornamenti. L’utente
                riconosce che il Software o parti dello stesso potrebbero non
                funzionare correttamente qualora non esegua tali aggiornamenti.
                L’utente accetta inoltre che tutti gli Aggiornamenti saranno
                considerati parte del Software e saranno soggetti a tutti i
                termini e le condizioni del presente EULA.
              </li>
            </ol>
          </li>

          <li>
            <b> LINK A SITI ESTERNI E ASSISTENZA </b>
            <ol>
              <li>
                L’utente può collegarsi a siti di terzi tramite l’uso del
                Software (ad esempio a “Team Viewer”, una piattaforma di
                assistenza informatica remota e di stampa di etichette esterne).
                I siti di terzi non sono sotto il controllo di TREND, la quale
                non è responsabile per i contenuti dei siti di terzi, i link
                presenti sui siti di terzi o eventuali modifiche o aggiornamenti
                a tali siti. TREND non è responsabile per il webcasting o
                qualsiasi altra forma di trasmissione ricevuta dai siti di
                terzi. TREND fornisce all’utente tali link ai siti di terzi solo
                per comodità non implicando l’inclusione di qualsiasi link
                un’approvazione da parte di TREND del sito di terzi cui rimanda.
              </li>
              <li>
                Per ulteriori informazioni sul Software o per eventuali problemi
                di utilizzo, visitare la pagina{" "}
                <a
                  href="https://www.trend-networks.com/in/en/index.aspx"
                  target="_blank"
                >
                  <b>www.trend-networks.com</b>
                </a>{" "}
                per gli indirizzi email regionali e i recapiti telefonici. TREND
                non sarà tenuta a fornire alcun servizio di assistenza ai sensi
                del presente EULA. Qualora l’utente abbia bisogno di assistenza
                potrà riceverla su richiesta in base ai tempi e costi previsti.
                Il presente EULA non conferisce all’utente alcun diritto ad
                aggiornamenti o upgrade del Software o ad alcuna estensione o
                miglioramento del Software sviluppato da o per conto di TREND in
                nessun momento nel futuro. TREND può offrire servizi di
                assistenza separatamente. Qualsiasi codice software
                supplementare o materiale correlato che TREND fornisce
                all’utente nell’ambito di qualsiasi servizio di assistenza deve
                essere considerato parte del Software e soggetto ai termini e
                alle condizioni del presente EULA.
              </li>
            </ol>
          </li>

          <li>
            <b> INFORMAZIONI RISERVATE </b> <br />
            L’utente riconosce e accetta che il Software (escluso qualsiasi
            Software open source) e tutte le informazioni provenienti dal
            Software e dalle attività di TREND, sotto qualsiasi forma, sono
            proprietà intellettuale di TREND e sono considerate informazioni
            riservate di TREND (<b>Informazioni riservate</b>). L’utente accetta
            di non consentire a chicchessia di duplicare, usare o divulgare ad
            alcuna persona tali Informazioni riservate, durante o dopo il
            periodo di efficacia del presente EULA, a meno che tale
            duplicazione, uso o divulgazione sia esplicitamente autorizzato/a da
            TREND per iscritto prima di qualsiasi diffusione. L’utente dovrà
            agire diligentemente e non utilizzare in nessun caso un grado di
            cura inferiore a quello adottato in relazione alle proprie
            informazioni riservate di natura analoga, per impedire la
            divulgazione o la riproduzione non autorizzata delle Informazioni
            riservate. Senza limitare la generalità di quanto sopra, nella
            misura in cui il presente EULA consenta la copia di Informazioni
            riservate, tutte le copie delle medesime dovranno contenere gli
            stessi avvisi di riservatezza, legende e designazioni dei diritti di
            proprietà intellettuale che appaiono nelle versioni originali e la
            parte terrà una documentazione dettagliata della collocazione di
            tutte le Informazioni riservate.
          </li>

          <li>
            <b> DIRITTO DI RISOLUZIONE DELL’EULA</b>
            <ol>
              <li>
                Il presente EULA continuerà ad applicarsi fino a risoluzione da
                parte dell’utente o di TREND come indicato nel presente
                documento.
              </li>
              <li>
                L’utente potrà recedere dal presente EULA in qualsiasi momento,
                interrompendo l’accesso al Software e/o disinstallandolo in modo
                permanente dal proprio computer nella sua interezza.
              </li>
              <li>
                I diritti dell’utente decadranno automaticamente e
                immediatamente senza preavviso da parte di TREND se l’utente non
                rispetta qualsiasi disposizione del presente EULA. In tal caso,
                l’utente dovrà interrompere immediatamente l’accesso al Software
                e/o disinstallarlo.
              </li>
              <li>
                TREND potrà revocare il diritto di utilizzo del Software
                concesso all’utente in qualsiasi momento, con o senza preavviso.
                I termini del presente EULA relativi a uso dei dati,
                risarcimento, limitazione di responsabilità, riservatezza,
                risoluzione delle controversie e interpretazione del contratto
                sopravvivranno alla risoluzione o alla scadenza del presente
                EULA.
              </li>
            </ol>
          </li>

          <li>
            <b> INDENNIZZO </b>
            <br />
            Nella misura massima consentita dalla legge, l’utente accetta di
            difendere, manlevare e tenere indenne TREND, le sue collegate e
            controllate nonché i rispettivi amministratori, funzionari,
            dipendenti e agenti da e contro qualsiasi reclamo, azione, causa o
            procedimento, oltre che da qualsiasi perdita, passività, danno,
            onere e spesa (incluse le ragionevoli spese legali) derivanti
            dall’utilizzo o maturate nell’ambito dell’utilizzo da parte
            dell’utente (o di chiunque agisca avvalendosi dell’account o della
            password dell’utente) del Software, ivi compresi l’accesso e/o
            l’installazione o l’uso del Software o la violazione del presente
            EULA da parte dell’utente.
          </li>

          <li>
            <b> LIMITAZIONE DI RESPONSABILITÀ</b>
            <ol>
              <li>
                TREND NON ESCLUDE O LIMITA IN ALCUN MODO LA PROPRIA
                RESPONSABILITÀ NEI CONFRONTI DELL’UTENTE NEI CASI IN CUI SAREBBE
                ILLEGALE FARLO. CIÒ INCLUDE LA RESPONSABILITÀ PER DECESSO O
                LESIONI PERSONALI CAUSATI DA NEGLIGENZA DI TREND O DEI SUOI
                DIPENDENTI, AGENTI O SUBAPPALTATORI O PER FRODE O DICHIARAZIONI
                FRAUDOLENTE.
              </li>
              <li>
                L’UTENTE RICONOSCE E ACCETTA ESPRESSAMENTE CHE L’USO DEL
                SOFTWARE AVVIENE A SUO RISCHIO E PERICOLO E CHE IL SOFTWARE È
                FORNITO “NELLO STATO DI FATTO, DIRITTO E DISPONIBILITÀ IN CUI SI
                TROVA” SENZA GARANZIE DI ALCUN TIPO, ESPLICITE O IMPLICITE.
                L’UTENTE È L’UNICO RESPONSABILE PER EVENTUALI DANNI AL PROPRIO
                COMPUTER O ALTRO DISPOSITIVO O PER LA PERDITA DI DATI DERIVANTI
                DA TALE USO. TREND ESCLUDE INOLTRE ESPRESSAMENTE QUALSIASI ALTRA
                GARANZIA E CONDIZIONE DI QUALSIASI TIPO, ESPLICITA O IMPLICITA,
                INCLUSE, A TITOLO ESEMPLIFICATIVO MA NON ESAUSTIVO, LE GARANZIE
                E LE CONDIZIONI IMPLICITE DI COMMERCIABILITÀ, IDONEITÀ A UNO
                SCOPO PARTICOLARE E NON VIOLAZIONE, CON RIGUARDO AL SOFTWARE.
                ALCUNE GIURISDIZIONI NON CONSENTONO LA RINUNCIA O L’ESCLUSIONE
                DI GARANZIE IMPLICITE, PERTANTO POTREBBERO NON APPLICARSI
                ALL’UTENTE. TREND NON FORNISCE ALCUNA GARANZIA CIRCA L’ASSENZA
                DI INTERFERENZE CON LA FRUIZIONE DEL SOFTWARE, LA RISPONDENZA
                DELLE FUNZIONI CONTENUTE O DEI SERVIZI ESEGUITI O FORNITI DAL
                SOFTWARE AI REQUISITI DELL’UTENTE, IL FUNZIONAMENTO ININTERROTTO
                O PRIVO DI ERRORI DEL SOFTWARE O DEI SERVIZI O LA CORREZIONE DEI
                DIFETTI DEL SOFTWARE O DEI SERVIZI. NESSUNA INFORMAZIONE O
                CONSIGLIO FORNITO VERBALMENTE O PER ISCRITTO DA TREND O DAI SUOI
                RAPPRESENTANTI AUTORIZZATI COSTITUIRÀ UNA GARANZIA.
              </li>
              <li>
                L’UTENTE COMPRENDE E ACCETTA ESPRESSAMENTE CHE, FATTA ECCEZIONE
                PER QUANTO RIGUARDA LA CLAUSOLA 10.1, TREND, LE SUE CONTROLLATE
                E COLLEGATE NONCHÉ I RISPETTIVI CONCESSORI DI LICENZA NON
                AVRANNO ALCUNA RESPONSABILITÀ NEI CONFRONTI DELL’UTENTE PER
                PERDITE O DANNI DI QUALSIVOGLIA NATURA O IMPORTO, IN BASE A
                QUALSIVOGLIA TEORIA DI RESPONSABILITÀ, A PRESCINDERE CHE TALI
                PERDITE O DANNI SIANO DIRETTI, INDIRETTI, INCIDENTALI, SPECIALI,
                CONSEQUENZIALI O ESEMPLARI E SE TALI PERDITE O DANNI SIANO STATI
                ARRECATI ALL’UTENTE O SUBITI DAL MEDESIMO ATTRAVERSO L’USO DEL
                SOFTWARE, IVI COMPRESA QUALSIASI PERDITA DI DATI O DANNO AI
                DISPOSITIVI DELL’UTENTE, E A PRESCINDERE DAL FATTO CHE L’UTENTE
                O I SUOI RAPPRESENTANTI SIANO STATI INFORMATI O AVREBBERO DOVUTO
                ESSERE CONSAPEVOLI DELLA POSSIBILITÀ DI TALI PERDITE.
              </li>
              <li>
                INVITIAMO L’UTENTE A ESEGUIRE IL BACKUP DEI CONTENUTI E DEI DATI
                UTILIZZATI CON IL SOFTWARE. TREND CONSIGLIA DI ESEGUIRE IL
                BACKUP DI QUALSIASI CONTENUTO E DATO UTILIZZATO IN CONNESSIONE
                CON IL SOFTWARE AL FINE DI PROTEGGERSI IN CASO DI PROBLEMI CON
                IL SOFTWARE.
              </li>
            </ol>
          </li>

          <li>
            <b> MODIFICHE ALL’EULA </b>
            <br />
            TREND potrà modificare l’EULA (incluso per quanto riguarda le
            commissioni dovute dall’utente per l’uso del Software) in qualsiasi
            momento, trasmettendone notifica all’utente (per mezzo di email, del
            Software, online o diversamente) e la modifica specificata sarà
            ritenuta vigente entro trenta (30) giorni dalla data della notifica.
            L’utente riconosce e accetta tali modifiche specificate nella
            notifica. Il mancato riconoscimento e accettazione di tali modifiche
            darà diritto a TREND di rescindere il presente EULA con un preavviso
            di un (1) mese.
          </li>

          <li>
            <b> NOTIFICHE </b>
            <ol>
              <li>
                Qualsiasi notifica o altra comunicazione fornita a una parte ai
                sensi o in connessione con il presente EULA sarà formulata per
                iscritto e consegnata a mano o tramite servizio di posta
                prepagata o altro servizio con consegna al giorno lavorativo
                successivo presso la sede legale (se una società) o principale
                (in qualsiasi altro caso) della parte.
              </li>
              <li>
                Qualsiasi notifica o comunicazione sarà considerata ricevuta:
                (i) se consegnata a mano, alla firma di una ricevuta di consegna
                o al momento in cui la notifica viene lasciata all’indirizzo
                corretto; (ii) se inviata tramite posta prepagata o altro
                servizio di consegna al giorno successivo, alle ore 9:00 del
                secondo giorno lavorativo successivo alla spedizione o al
                momento riportato dal servizio di consegna; e (iii) se inviata
                via email, al momento della trasmissione, oppure, se l’invio
                avviene al di fuori dell’orario di lavoro del luogo di
                ricezione, alla ripresa dell’orario lavorativo (dalle 9:00 alle
                17:00, dal lunedì al venerdì, per un giorno non festivo nel
                luogo di ricezione).
              </li>
            </ol>
          </li>

          <li>
            <b> LEGGE APPLICABILE E GIURISDIZIONE</b>
            Il presente EULA e qualsiasi controversia o rivendicazione (comprese
            le controversie o le rivendicazioni di natura non contrattuale)
            derivanti dal contratto di licenza per l’utente finale o attinenti
            allo stesso o all’oggetto o alla conclusione del contratto saranno
            disciplinati e interpretati in conformità alle leggi
            dell’Inghilterra e del Galles e ciascuna parte accetta
            irrevocabilmente che i tribunali dell’Inghilterra e del Galles
            avranno giurisdizione esclusiva per risolvere qualsiasi controversia
            o rivendicazione (comprese le controversie o le rivendicazioni di
            natura non contrattuale) derivanti dal presente EULA o attinenti
            allo stesso o all’oggetto o alla conclusione del contratto.
          </li>

          <li>
            <b>DISPOSIZIONI VARIE</b>
            <br />
            Il presente EULA (incluso qualsiasi addendum o modifica al medesimo)
            costituisce l’intero accordo tra l’utente e TREND relativamente al
            Software e ai servizi di assistenza (se presenti) e sostituisce
            tutte le comunicazioni orali o scritte precedenti o contemporanee,
            le proposte e le dichiarazioni relative al Software o a qualsiasi
            altro argomento coperto dal presente EULA. Nella misura in cui i
            termini di qualsiasi informativa di TREND o i termini dei servizi di
            assistenza siano in conflitto con i termini del presente EULA, i
            termini del presente EULA prevarranno. Qualora una qualsiasi
            disposizione del presente EULA venga giudicata nulla, invalida,
            inapplicabile o illegale, tale disposizione verrà riformulata al
            fine di riflettere l’intenzione originale delle parti nella massima
            misura possibile e in conformità alla legge applicabile mentre le
            altre disposizioni continueranno ad avere piena validità ed
            efficacia. Il mancato esercizio o applicazione da parte di TREND di
            qualsiasi diritto o disposizione del presente EULA non costituirà
            una rinuncia a tale diritto o disposizione, a meno che tale rinuncia
            non sia riconosciuta e convenuta da TREND per iscritto. Né la
            condotta tra le parti né la prassi commerciale avranno la forza di
            modificare una qualsiasi disposizione del presente EULA. L’utente
            non può cedere il presente EULA né alcuno dei propri diritti ai
            sensi del medesimo senza il previo consenso scritto di TREND, il
            quale potrà essere concesso o vincolato, a esclusiva e assoluta
            discrezione di TREND, e qualsiasi tentativo di cessione senza tale
            consenso sarà nullo e invalido. Nel rispetto della limitazione
            precedente, il presente EULA sarà pienamente vincolante per TREND e
            i rispettivi eredi e aventi causa ed entrerà in vigore a vantaggio
            di tali soggetti, i quali potranno provvedere all’applicazione dello
            stesso. TREND potrà trasferire i propri diritti e obblighi ai sensi
            dei presenti termini ad un’altra organizzazione. hts and obligations
            under these terms to another organisation.
          </li>
        </ol>
      </span>
    </React.Fragment>
  );
};

export default TermsAndCondition;
